import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";

const milestones = [
  { year: "2018", title: "项目立项", description: "创始团队组建完成，确立以数据驱动体育观赛的核心理念，开始产品原型设计。" },
  { year: "2019", title: "V1.0 发布", description: "大满贯APP首个版本正式上线，覆盖主流足球赛事直播，获得首批10万用户。" },
  { year: "2020", title: "用户突破500万", description: "凭借精准的数据分析和流畅的直播体验，用户量实现爆发式增长，赛事覆盖面扩展至篮球、网球。" },
  { year: "2021", title: "AI分析引擎上线", description: "自主研发的AI赛事预测模型上线，预测准确率达到70%，行业领先。" },
  { year: "2022", title: "千万用户里程碑", description: "累计用户突破1000万，成为国内领先的体育数据平台之一。" },
  { year: "2023", title: "技术升级", description: "全面升级直播技术架构，支持4K超清画质，延迟降低至1秒以内。" },
  { year: "2024", title: "生态拓展", description: "支持智能穿戴设备数据接入，构建完整的体育数据生态体系。" },
  { year: "2025", title: "AI 2.0 时代", description: "AI预测准确率突破75%，推出个性化推荐系统，用户体验全面升级。" },
  { year: "2026", title: "全新里程碑", description: "累计用户突破5000万，持续技术创新，引领体育科技行业未来。" },
];

const honors = [
  { title: "最佳体育科技应用", org: "中国体育产业协会", year: "2025" },
  { title: "用户最喜爱APP TOP10", org: "应用宝年度评选", year: "2025" },
  { title: "最佳创新产品奖", org: "全球移动互联网大会", year: "2024" },
  { title: "数据安全认证", org: "国家信息安全等级保护三级", year: "2024" },
  { title: "年度最佳设计奖", org: "中国UX设计大奖", year: "2023" },
];

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于大满贯APP",
  description: "大满贯APP品牌介绍、发展历程与联系方式",
  url: `${window.location.origin}/about`,
  mainEntity: {
    "@type": "Organization",
    name: "大满贯APP",
    description: "专业的体育赛事直播与数据分析平台，为体育爱好者提供极致的观赛体验。",
    foundingDate: "2018",
    url: window.location.origin,
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: "support@daman.com",
      telephone: "+86-400-888-9999",
      availableLanguage: ["Chinese"],
    },
  },
};

export default function About() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "关于我们" }]} />
            <div className="px-4 md:px-6 pb-6">
              <h1 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-2">
                关于大满贯
              </h1>
              <p className="text-foreground-500 text-sm">了解我们的品牌、历史与使命</p>
            </div>
          </div>
        </div>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-display-sm md:text-display-md text-foreground-900 mb-6">
                  用科技重新定义体育观赛
                </h2>
                <div className="space-y-4 text-base text-foreground-600 leading-relaxed">
                  <p>
                    大满贯APP诞生于2018年，由一群热爱体育的技术极客创立。我们深信，数据和技术能够让体育观赛变得更加精彩、更加专业。
                  </p>
                  <p>
                    经过多年的技术积累和产品打磨，大满贯已经成为国内领先的体育赛事直播与数据分析平台，累计服务超过5000万用户，覆盖足球、篮球、网球等200余项赛事。
                  </p>
                  <p>
                    我们的使命是让每一位体育爱好者都能享受到专业级别的观赛体验。无论是实时数据、AI分析还是多维度赛事解读，大满贯都在不断突破技术的边界。
                  </p>
                  <p>
                    未来，大满贯将继续深耕体育科技领域，探索AI、AR等前沿技术在体育观赛中的应用，为用户创造更多惊喜和可能。
                  </p>
                </div>
              </div>

              <div className="rounded-2xl overflow-hidden h-[400px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20sports%20technology%20company%20office%20with%20team%20collaboration%2C%20large%20screens%20displaying%20sports%20data%20analytics%2C%20warm%20orange%20brand%20colors%2C%20creative%20workspace%2C%20professional%20corporate%20photography%2C%20clean%20modern%20aesthetic&width=800&height=600&seq=about-brand-image&orientation=landscape"
                  alt="大满贯团队"
                  title="大满贯APP团队 - 专业体育科技"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-display-sm md:text-display-md text-foreground-900 mb-4 text-center">
              发展历程
            </h2>
            <p className="text-foreground-500 text-base text-center mb-12 max-w-xl mx-auto">
              从0到5000万，每一步都凝聚着团队的坚持与创新
            </p>

            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 md:-translate-x-px"></div>
              <div className="flex flex-col gap-8">
                {milestones.map((item, index) => (
                  <div
                    key={index}
                    className={`relative flex flex-col md:flex-row gap-6 ${
                      index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                    }`}
                  >
                    <div className="hidden md:block flex-1"></div>
                    <div className="absolute left-2.5 md:left-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 md:-translate-x-1.5 mt-1.5"></div>
                    <div className="flex-1 pl-10 md:pl-0">
                      <div className={`p-5 rounded-xl bg-background-50 border border-background-200/70 ${
                        index % 2 === 1 ? "md:pr-10 md:text-right" : "md:pl-10"
                      }`}>
                        <span className="inline-block px-2.5 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-bold mb-2">
                          {item.year}
                        </span>
                        <h3 className="text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                        <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-display-sm md:text-display-md text-foreground-900 mb-4 text-center">
              荣誉资质
            </h2>
            <p className="text-foreground-500 text-base text-center mb-12 max-w-xl mx-auto">
              行业认可，是我们前行的最大动力
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
              {honors.map((honor, index) => (
                <div
                  key={index}
                  className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center hover:border-accent-200 transition-all duration-300"
                >
                  <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                    <i className="ri-award-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1.5">{honor.title}</h3>
                  <p className="text-xs text-foreground-500 mb-1">{honor.org}</p>
                  <span className="text-xs text-accent-600 font-medium">{honor.year}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-display-sm md:text-display-md text-foreground-900 mb-4 text-center">
              联系我们
            </h2>
            <p className="text-foreground-500 text-base text-center mb-12 max-w-xl mx-auto">
              有任何问题或合作意向，欢迎随时联系我们
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1.5">电子邮箱</h3>
                <p className="text-sm text-foreground-500">support@daman.com</p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-phone-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1.5">客服热线</h3>
                <p className="text-sm text-foreground-500">400-888-9999</p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1.5">公司地址</h3>
                <p className="text-sm text-foreground-500">广东省深圳市南山区科技园南路88号</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}